module.exports = __webpack_public_path__ + "img/2.dff2d880.png";